import { Button } from '@zenterprise-inc/ui';

import { useChangePasswordContext } from '@/components/my/password/contexts/ChangePasswordProvider';

export const CurrentPasswordCta = () => {
  const { isLengthError } = useChangePasswordContext();

  return (
    <>
      <Button.StickyBottom.Wrapper className="page-padding">
        <Button.StickyBottom.Button disabled={isLengthError} type={'submit'} state="primary">
          다음
        </Button.StickyBottom.Button>
      </Button.StickyBottom.Wrapper>
    </>
  );
};
